export const THEME_STORAGE_KEY = 'cleanor-theme';

export type ThemePreference = 'dark' | 'light' | 'system';
export type ThemeMode = 'dark' | 'light';

export type ThemeChangeDetail = {
  preference: ThemePreference;
  theme: ThemeMode;
};

export function isThemePreference(value: string | null | undefined): value is ThemePreference {
  return value === 'dark' || value === 'light' || value === 'system';
}

export function resolveThemePreference(
  preference: ThemePreference,
  systemPrefersLight: boolean,
): ThemeMode {
  if (preference === 'system') {
    return systemPrefersLight ? 'light' : 'dark';
  }

  return preference;
}

export const themeBootstrapScript = `
(() => {
  try {
    const storedPreference = window.localStorage.getItem('${THEME_STORAGE_KEY}');
    const preference =
      storedPreference === 'light' || storedPreference === 'dark' || storedPreference === 'system'
        ? storedPreference
        : 'dark';
    const systemPrefersLight =
      preference === 'system' &&
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: light)').matches;
    const theme = preference === 'system' ? (systemPrefersLight ? 'light' : 'dark') : preference;
    document.documentElement.dataset.themePreference = preference;
    document.documentElement.dataset.theme = theme;
  } catch {
    document.documentElement.dataset.themePreference = 'dark';
    document.documentElement.dataset.theme = 'dark';
  }
})();
`;
